import { t } from 'i18next';
import z from 'zod';
import type { TeamRoleApiResponse } from '../types';

// `satisfies readonly TeamRoleApiResponse[]` just tells TS that TEAM_ROLES is an array of values
// which are all of type TeamRoleApiResponse. If roles ever change, this code would throw an error.
const TEAM_ROLES = ['admin', 'external'] as const satisfies readonly TeamRoleApiResponse[];

export const inviteMemberFormSchema = z.object({
  email: z
    .string()
    .trim()
    .nonempty(t('errors:forms.string.non_empty'))
    .pipe(z.email(t('errors:forms.string.email'))),
  role: z.enum(TEAM_ROLES),
});

export type TeamSettingsInviteFormValues = z.input<typeof inviteMemberFormSchema>;
